import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCGg_UfTocUNJSz86TYBZN4bB5uk8iVKao",
    authDomain: "clone-yt-ee492.firebaseapp.com",
    projectId: "clone-yt-ee492",
    storageBucket: "clone-yt-ee492.appspot.com",
    messagingSenderId: "654572164689",
    appId: "1:654572164689:web:75e117ca4d0b536aec0a70",
    measurementId: "G-VRMQ7GT224"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { db, auth, provider };